import { useState, useContext } from "react";
import { login } from "../auth/authService";
import { AuthContext } from "../auth/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const { loginUser } = useContext(AuthContext);
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const submitHandler = async (e) => {
        e.preventDefault();

        if (loading) return;

        if (!username.trim()) {
            toast.error("لطفاً شماره موبایل را وارد کنید.");
            return;
        }

        if (!password) {
            toast.error("لطفاً رمز عبور را وارد کنید.");
            return;
        }

        setLoading(true);

        try {
            const data = await login(username.trim(), password);

            loginUser(data);

            window.location.href = "/";
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "ورود انجام نشد. لطفاً اطلاعات وارد شده را بررسی کنید."
            );

            setLoading(false);
        }
    };

    return (
        <div
            dir="rtl"
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={{
                background:
                    "linear-gradient(135deg, #f5f7ff 0%, #eef2ff 100%)",
                padding: "16px",
            }}
        >
            <div
                className="w-100"
                style={{
                    maxWidth: "430px",
                }}
            >
                <form
                    onSubmit={submitHandler}
                    className="bg-white rounded-4 shadow-sm p-3 p-sm-4 p-md-5"
                >
                    {/* Header */}
                    <div className="text-center mb-4">
                        <div
                            className="d-flex align-items-center justify-content-center mx-auto mb-3"
                            style={{
                                width: "64px",
                                height: "64px",
                                borderRadius: "18px",
                                background: "#eef2ff",
                                color: "#4f46e5",
                                fontSize: "30px",
                            }}
                        >
                            🎓
                        </div>

                        <h1 className="fw-bold mb-4" style={{ color: "#1f2937", fontSize: "clamp(1.4rem, 5vw, 1.75rem)", }} > ورود به سامانه </h1>

                        {/* <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }} > برای ادامه وارد حساب کاربری خود شوید </p> */}
                    </div>

                    {/* Mobile Number */}
                    <div className="mb-3">
                        <label
                            htmlFor="username"
                            className="form-label fw-semibold"
                            
                        >
                            شماره موبایل
                        </label>

                        <div className="position-relative">
                            <span
                                className="position-absolute top-50 translate-middle-y text-muted"
                                style={{
                                    right: "14px",
                                    zIndex: 5,
                                    fontSize: "18px",
                                }}
                            >
                                📱
                            </span>

                            <input
                                id="username"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="off"
                                className="form-control form-control-lg"
                                placeholder="09"
                                value={username}
                                onChange={(e) =>
                                    setUsername(e.target.value)
                                }
                                disabled={loading}
                                style={{
                                    paddingRight: "45px",
                                    borderRadius: "12px",
                                    minHeight: "52px",
                                }}
                            />
                        </div>
                    </div>

                    {/* Password */}
                    <div className="mb-4">
                        <label
                            htmlFor="password"
                            className="form-label fw-semibold"
                        >
                            رمز عبور
                        </label>

                        <div className="position-relative">
                            <span
                                className="position-absolute top-50 translate-middle-y text-muted"
                                style={{
                                    right: "14px",
                                    zIndex: 5,
                                    fontSize: "18px",
                                }}
                            >
                                🔒
                            </span>

                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                autoComplete="off"
                                className="form-control form-control-lg"
                                placeholder=""
                                value={password}
                                onChange={(e) =>
                                    setPassword(e.target.value)
                                }
                                disabled={loading}
                                style={{
                                    paddingRight: "45px",
                                    paddingLeft: "50px",
                                    borderRadius: "12px",
                                    minHeight: "52px",
                                    direction: "ltr",
                                }}
                            />

                            <button
                                type="button"
                                className="btn position-absolute top-50 translate-middle-y p-0 border-0 text-muted"
                                style={{
                                    left: "14px",
                                    zIndex: 5,
                                }}
                                onClick={() =>
                                    setShowPassword((prev) => !prev)
                                }
                                disabled={loading}
                                aria-label={
                                    showPassword
                                        ? "مخفی کردن رمز عبور"
                                        : "نمایش رمز عبور"
                                }
                            >
                                {showPassword ? "🙈" : "👁️"}
                            </button>
                        </div>
                    </div>

                    {/* Login */}
                    <button
                        type="submit"
                        className="btn btn-primary btn-lg w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
                        disabled={loading}
                        style={{
                            borderRadius: "12px",
                            minHeight: "52px",
                            background: "#4f46e5",
                            border: "none",
                        }}
                    >
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                />

                                <span>در حال ورود...</span>
                            </>
                        ) : (
                            "ورود به سامانه"
                        )}
                    </button>

                    {/* Create School */}
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-lg w-100"
                        disabled={loading}
                        onClick={() => navigate("/create-school")}
                        style={{
                            borderRadius: "12px",
                            minHeight: "52px",
                        }}>+ مدرسه جدید</button>
                </form>

                {/* Toast */}
                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    rtl
                    theme="light"
                />
            </div>
        </div>
    );
};

export default Login;
